import {
	RouletteContainer,
	RouletteTittle,
} from "pages/b2b/Roulette/Roulette.style";
import { ReactComponent as RouletteLogoBam } from "assets/roulette-bam.svg";
import { ReactComponent as RouletteLogoTsl } from "assets/roulette-tsl.svg";
import { Stack } from "@mui/material";

import { RouletteWheel } from "./RouletteWheel";
import { VerticalWheel } from "./VerticalWheel";
import { ReactComponent as BamLogo } from "assets/logo-bam.svg";
import type { PartialSong } from "@redux/player/types";
import type { Playlist } from "src/@types/api-types";
import rouletteMP3 from "assets/roulette-song.mp3";

import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { withBamLayoutSelector } from "@redux/user/selectors";
import { TslLogo } from "../B2bPlayerArea/B2bPlayerArea.style";

interface Props {
	launchRoulette: {
		players: string[];
		song: PartialSong;
		selectedPlayer: number;
		playlist: Playlist;
	} | null;
	onAnimationStop: () => void;
}

export const TVRoulette = ({ launchRoulette, onAnimationStop }: Props) => {
	const audioRef = useRef<HTMLAudioElement>(null);
	const withBamLayout = useSelector(withBamLayoutSelector);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (launchRoulette && audioRef.current) {
			audioRef.current.play();
		}
		() => {
			if (audioRef.current) {
				audioRef.current.pause();
				audioRef.current.remove();
			}
		};
	}, [launchRoulette, audioRef]);

	return (
		<RouletteContainer withBamLayout={withBamLayout}>
			<Stack
				direction={"column"}
				alignItems="center"
				justifyContent={"space-between"}
				sx={{
					width: "100%",
					height: "100%",
				}}
			>
				{!launchRoulette && <div />}
				<Stack
					margin={2}
					sx={{ width: launchRoulette ? "20%" : "70%" }}
					justifyContent={"center"}
					alignItems={"center"}
				>
					{withBamLayout ? <RouletteLogoBam /> : <RouletteLogoTsl />}
				</Stack>

				{launchRoulette && (
					<Stack width={"100%"} height={"100%"}>
						<Stack
							direction={"row"}
							width={"100%"}
							justifyContent={"space-around"}
						>
							<RouletteTittle>
								<FormattedMessage id="game.roulette.who" />
							</RouletteTittle>
							<RouletteTittle>
								<FormattedMessage id="game.roulette.what" />
							</RouletteTittle>
						</Stack>
						<Stack
							direction={"row"}
							alignItems={"center"}
							justifyContent={"space-between"}
							width={"100%"}
							height={"80%"}
						>
							<Stack
								direction={"column"}
								alignItems="center"
								justifyContent={"center"}
								width={"80%"}
								height={"80%"}
							>
								<RouletteWheel
									launchRoulette={launchRoulette}
									onStopSpinning={onAnimationStop}
								/>
							</Stack>
							<Stack
								direction={"column"}
								alignItems={"center"}
								width={"80%"}
								height={"80%"}
								justifyContent={"center"}
							>
								<VerticalWheel
									song={launchRoulette.song}
									playlist={launchRoulette.playlist}
								/>
							</Stack>
						</Stack>
					</Stack>
				)}
				<Stack sx={{ width: "100%", alignItems: "center" }} margin={2}>
					{withBamLayout ? <BamLogo width={"10%"} /> : <TslLogo />}
				</Stack>
			</Stack>

			{launchRoulette && (
				// biome-ignore lint/a11y/useMediaCaption: <explanation>
				<audio ref={audioRef} src={rouletteMP3} loop />
			)}
		</RouletteContainer>
	);
};
